import { loadTranslations } from 'react-redux-i18n'
import { store } from '../../../../../app/store'

store.dispatch(
  loadTranslations({
    en: {
      ...store.getState().i18n.translations.en,
      userManagement: {
        ...store.getState().i18n.translations.en.userManagement,
        upgradeViewPlan: {
          UPGRADE: 'Upgrade',
          CURRENT_PLAN: 'Current Plan',
          SUBSCRIPTION_FEE: 'Subscription Fee',
          BENEFITS: 'Benefits',
          LEARN_MORE: 'Learn more',
          PACKAGE: 'Package',
          TRADE_DISCOUNT_UPTO: 'Trade Discount up to',
          UPGRADE_TO: 'UPGRADE TO',
          FREE: 'Free',
          ONLY_FROM: 'Only from',
          MONTH: 'Month',
          UPGRADE_TO_STANDARD: 'UPGRADE TO STANDARD',
          UPGRADE_TO_PREMIUM: 'UPGRADE TO PREMIUM',
          SUB_TITLE_BASIC: 'Pay as you go',
          SUB_TITLE_LITE: 'Buy in bulk',
          SUB_TITLE_PREMIUM: 'Subscription Plan',
          SUB_TITLE_CUSTOM: 'Build your own plan.',
          benefitCustomPlan: {
            FIRST: 'Choose from every features you need.',
            SECOND: 'API Integration.',
            THIRD: 'Select data that works for you.',
            FOURTH: 'Customize Packages.',
          },
        },
        buyPackage: {
          BUY_PACKAGE: 'Buy package',
          CHOOSE_YOUR_PACKAGE: 'Choose your package',
          PACKAGE_LIST: 'Package List',
          PACKAGE_TYPE: 'Package Type',
          VOLUME: 'Volume',
          UNIT_PRICE: 'Unit Price',
          TOTAL: 'Total',
          TOTAL_PRICE: 'Total Price',
          PRICE: 'Price',
          TRADE_DISCOUNT: 'Trade Discount on Order',
          VAT: 'VAT',
          GRAND_TOTAL: 'Grand Total',
          SELECT_ENTER_CODE: 'Select or enter a code',
          ADD_NEW_PACKAGE: 'Add new package',
          ALL_PRICE_INCLUDE: 'All the prices include VAT',
          GET_QUOTATION: 'Get Quotation',
          CREATE_REQUEST: 'Create Request',
          BUY_NOW: 'Buy now',
          INSERT_VOLUME: 'Insert volume',
          VOLUME_TOOLTIP: 'Unit price changes based on volume',
          PLACE_ORDER: 'Place Order',
          TEXT_INVALID_VOLUME: 'You have not entered volume',
        },
        quotationInfo: {
          QUOTATION_INFO: 'Quotation Information',
          SAMPLE_QUOTATION: 'Sample Quotation',
          CLIENT_NAME: 'Client Name',
          JOB_TITLE: 'Job Title',
          EMAIL: 'Email',
          PHONE: 'Phone',
          COMPANY_NAME: 'Company Name',
          COMPANY_ADDRESS: 'Company Address',
          TAX_CODE: 'Tax Code',
          DOWNLOAD_QUOTATION: 'Download Quotation',
        },
        contractInfo: {
          CONTRACT_INFO: 'Contract Information',
          REPRESENTATIVE: 'Representative',
          OTHER_CONTACT_DETAILS: 'Other Contact Detail',
          SEND_REQUEST: 'Send Request',
          SAMPLE_CONTRACT: 'Sample Contract',
          FAX: 'Fax',
          LANGUAGE: 'Language for Contract',
        },
        viewDetailPlans: {
          TITLE: 'View Detail',
          FEATURE: 'Feature',
        },
        packageList: {
          TITLE: 'Package List',
          SERVICE: 'Service',
          USER_TYPE: 'User Type',
          SAVING_PER_REPORT: 'Savings per report',
          CONTACT_US: 'Contact us for the best offer',
          SAVE: 'Save',
          FROM: 'From',
          COMPANIES: 'companies',
        },
        paymentMethod: {
          PAYMENT_METHOD: 'Payment Method',
          PACKAGE: 'Package',
          BANK_TRANSFERS: 'Bank Transfer',
          CARD: 'Card',
          POST_PAID: 'Post-paid',
          CURRENCY_OF_PAYMENT: 'Currency of Payment',
          CHECKBOX_CONTRACT_TITLE: 'I want to receive contract.',
          YOUR_PACKAGE: 'Your Package',
          SUCCESSFULLY_TRIGGER: 'has been successfully triggered.',
          AVAILABLE_PACKAGE_IS: 'Available package is',
          VALID: 'Valid',
          COMPANIES: 'Companies',
          REPORTS: 'Reports',
          CONFIRM_SUCCESS_PACKAGE: 'You have paid successfully',
          CONFIRM_FAIL_PACKAGE: 'Your payment is failed',
          YOUR_ACCOUNT_UPGRADED:
            'Your account has been successfully upgraded to',
          CONFIRM_POST_PAID:
            'Your request has been submit successfully. We will contact you soon.',
          FROM: 'from',
          TO: 'to',
        },
        paymentInformation: {
          TITLE: 'Payment Information',
          INVOICE_RECEIVING: 'Invoice Receiving Information',
          CUSTOMER_NAME: 'Customer name',
          COMPANY_NAME: 'Company name',
          COMPANY_ADDRESS: 'Company Address',
          TAX_CODE: 'Tax Code',
          INVOICE_EMAIL: 'Invoice Receiving Email',
          PHONE: 'Phone',
          NOTE: 'Note: The invoice will be sent to your email once we received bank confirmation.',
          PAY_NOW: 'Pay Now',
          CHECKOUT: 'Check Out',
        },
        upgradeAccount: {
          UPGRADE: 'Upgrade Account',
          SUBSCRIPTION_TYPE: 'Subscription Type',
          SUBSCRIPTION_TERMS: 'Subscription Terms',
          PRICE: 'Price',
          BUY_PACKAGE_QUESTION:
            'Would you like to buy any packages in addition to this upgrade?',
          MONTHS: ' months',
          YEAR: 'year',
          NOTE: `The trade discount for this order only applies to the package purchase's value`,
          TOTAL_PRICE: 'Total Price',
        },
        valid: {
          email: 'Enter new email to send request',
          country: 'Select new country to send request',
          companyName: 'Enter new company name to send request',
          taxCode: 'Enter new tax code to send request',
          industry: 'Select new industry to send request',
          none: 'Select filed wanting to change and enter value to send request',
        },
      },
    },
    vi: {
      ...store.getState().i18n.translations.vi,
      userManagement: {
        ...store.getState().i18n.translations.vi.userManagement,
        upgradeViewPlan: {
          UPGRADE: 'Nâng cấp',
          CURRENT_PLAN: 'Tài khoản hiện tại',
          SUBSCRIPTION_FEE: 'Phí đăng ký',
          BENEFITS: 'Các lợi ích',
          LEARN_MORE: 'Tìm hiểu thêm',
          PACKAGE: 'Gói',
          TRADE_DISCOUNT_UPTO: 'Chiết khấu thương mại lên đến',
          UPGRADE_TO: 'Nâng cấp lên',
          FREE: 'Free',
          ONLY_FROM: 'Chỉ từ',
          MONTH: 'Tháng',
          UPGRADE_TO_STANDARD: 'NÂNG CẤP LÊN STANDARD',
          UPGRADE_TO_PREMIUM: 'NÂNG CẤP LÊN PREMIUM',
          SUB_TITLE_BASIC: 'Thanh toán khi sử dụng',
          SUB_TITLE_LITE: 'Mua các gói trả trước',
          SUB_TITLE_PREMIUM: 'Đăng ký gói tài khoản kì hạn',
          SUB_TITLE_CUSTOM: 'Tạo tài khoản tùy chỉnh.',
          benefitCustomPlan: {
            FIRST: 'Lựa chọn từ mọi tính năng bạn cần.',
            SECOND: 'Tích hợp API.',
            THIRD: 'Chọn dữ liệu phù hợp với bạn.',
            FOURTH: 'Tùy chỉnh gói.',
          },
        },
        buyPackage: {
          BUY_PACKAGE: 'Mua gói',
          CHOOSE_YOUR_PACKAGE: 'Chọn Gói Của Bạn',
          PACKAGE_LIST: 'Danh sách gói',
          PACKAGE_TYPE: 'Loại gói',
          VOLUME: 'Số lượng',
          UNIT_PRICE: 'Đơn giá',
          TOTAL: 'Tổng',
          TOTAL_PRICE: 'Tổng Tiền',
          PRICE: 'Giá',
          TRADE_DISCOUNT: 'CKTM cho Đơn Hàng',
          VAT: 'VAT',
          GRAND_TOTAL: 'Tổng Thanh Toán',
          SELECT_ENTER_CODE: 'Chọn hoặc nhập mã',
          ADD_NEW_PACKAGE: 'Thêm gói mới',
          ALL_PRICE_INCLUDE: 'Giá đã bao gồm VAT',
          GET_QUOTATION: 'Nhận báo giá',
          CREATE_REQUEST: 'Tạo yêu cầu',
          BUY_NOW: 'Mua ngay',
          INSERT_VOLUME: 'Nhập số lượng',
          VOLUME_TOOLTIP: 'Đơn giá thay đổi theo số lượng',
          PLACE_ORDER: 'Đặt hàng',
          TEXT_INVALID_VOLUME: 'Bạn chưa nhập số lượng',
        },
        quotationInfo: {
          QUOTATION_INFO: 'Thông tin báo giá',
          SAMPLE_QUOTATION: 'Mẫu báo giá',
          CLIENT_NAME: 'Tên khách hàng',
          JOB_TITLE: 'Chức danh',
          EMAIL: 'Email',
          PHONE: 'Số điện thoại',
          COMPANY_NAME: 'Tên công ty',
          COMPANY_ADDRESS: 'Địa chỉ công ty',
          TAX_CODE: 'Mã số thuế',
          DOWNLOAD_QUOTATION: 'Tải báo giá',
        },
        contractInfo: {
          CONTRACT_INFO: 'Thông tin hợp đồng',
          REPRESENTATIVE: 'Đại diện bởi',
          OTHER_CONTACT_DETAILS: 'Thông tin liên lạc khác',
          FAX: 'Fax',
          SEND_REQUEST: 'Gửi Yêu Cầu',
          SAMPLE_CONTRACT: 'Hợp đồng mẫu',
          LANGUAGE: 'Ngôn Ngữ cho Hợp Đồng',
        },
        viewDetailPlans: {
          TITLE: 'Các gói tài khoản',
          FEATURE: 'Tính năng',
        },
        packageList: {
          TITLE: 'DANH SÁCH GÓI',
          SERVICE: 'Dịch vụ',
          USER_TYPE: 'Loại người dùng',
          SAVING_PER_REPORT: 'Tiết kiệm trên mỗi báo cáo',
          CONTACT_US: 'Liên hệ chúng tôi để nhận ưu đãi tốt nhất',
          SAVE: 'Tiết kiệm',
          FROM: 'Từ',
          COMPANIES: 'công ty',
        },
        paymentMethod: {
          PAYMENT_METHOD: 'Hình thức thanh toán',
          PACKAGE: 'Gói',
          BANK_TRANSFERS: 'Chuyển khoản',
          CARD: 'Thẻ',
          POST_PAID: 'Thanh toán sau',
          CURRENCY_OF_PAYMENT: 'Đồng Tiền Thanh Toán',
          CHECKBOX_CONTRACT_TITLE: 'Tôi muốn nhận hợp đồng.',
          YOUR_PACKAGE: 'Gói',
          SUCCESSFULLY_TRIGGER: 'của bạn đã được kích hoạt thành công.',
          AVAILABLE_PACKAGE_IS: 'Số dư sẵn sàng sử dụng là',
          VALID: 'Giá trị sử dụng',
          COMPANIES: 'công ty',
          REPORTS: 'báo cáo',
          CONFIRM_SUCCESS_PACKAGE: 'Bạn đã thanh toán thành công',
          CONFIRM_FAIL_PACKAGE: 'Thanh toán thất bại',
          YOUR_ACCOUNT_UPGRADED:
            'Tài khoản của bạn đã được nâng cấp thành công lên',
          CONFIRM_POST_PAID:
            'Yêu cầu của bạn đã được gửi thành công. Chúng tôi sẽ liên hệ bạn sớm.',
          FROM: 'từ',
          TO: 'đến',
        },
        paymentInformation: {
          TITLE: 'Thông Tin Thanh Toán',
          INVOICE_RECEIVING: 'Thông tin nhận hóa đơn',
          CUSTOMER_NAME: 'Tên khách hàng',
          COMPANY_NAME: 'Tên công ty',
          COMPANY_ADDRESS: 'Địa chỉ công ty',
          TAX_CODE: 'Mã số thuế',
          INVOICE_EMAIL: 'Email nhận hóa đơn',
          PHONE: 'Số điện thoại',
          NOTE: 'Lưu ý: Hóa đơn sẽ được gửi đến email của bạn sau khi chúng tôi nhận được xác nhận của ngân hàng.',
          PAY_NOW: 'Thanh toán ngay',
          CHECKOUT: 'Mua hàng',
        },
        upgradeAccount: {
          UPGRADE: 'Nâng cấp tài khoản',
          SUBSCRIPTION_TYPE: 'Loại tài khoản',
          SUBSCRIPTION_TERMS: 'Kỳ hạn',
          PRICE: 'Giá',
          BUY_PACKAGE_QUESTION:
            'Bạn có muốn mua thêm gói dịch vụ khi nâng cấp tài khoản không?',
          MONTHS: ' tháng',
          YEAR: ' năm',
          NOTE: `CKTM cho đơn hàng chỉ được tính trên tổng giá trị của giao dịch mua gói`,
          TOTAL_PRICE: 'Tổng',
        },
        valid: {
          email: 'Nhập địa chỉ email mới để gửi yêu cầu',
          country: 'Chọn quốc gia mới để gửi yêu cầu',
          companyName: 'Nhập tên công ty mới mới để gửi yêu cầu',
          taxCode: 'Nhập mã số thuế mới mới để gửi yêu cầu',
          industry: 'Chọn ngành mới để gửi yêu cầu',
          none: 'Chọn thông tin bạn muốn thay đổi và nhập giá trị để tạo yêu cầu',
        },
      },
    },
  }),
)
